import api from './api';

const documentService = {
  upload: async (file, data) => {
    const formData = new FormData();
    formData.append('file', file);
    
    if (data.address_id) formData.append('address_id', data.address_id);
    if (data.project_id) formData.append('project_id', data.project_id);
    if (data.appointment_id) formData.append('appointment_id', data.appointment_id);
    if (data.real_estate_object_id) formData.append('real_estate_object_id', data.real_estate_object_id);
    if (data.vehicle_id) formData.append('vehicle_id', data.vehicle_id);
    if (data.document_type) formData.append('document_type', data.document_type);
    if (data.folder_id) formData.append('folder_id', data.folder_id);
    if (data.title) formData.append('title', data.title);
    if (data.description) formData.append('description', data.description);
    if (data.category) formData.append('category', data.category);
    if (data.notes) formData.append('notes', data.notes);
    if (data.linked_address_id) formData.append('linked_address_id', data.linked_address_id);
    if (data.linked_contact_person_id) formData.append('linked_contact_person_id', data.linked_contact_person_id);
    
    const response = await api.post('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Allgemeine Dokumentliste mit Filtern (address_id, project_id, limit …)
  getAll: async (params = {}) => {
    const response = await api.get('/documents', { params });
    return response.data;
  },

  getByAddress: async (addressId) => {
    const response = await api.get('/documents', {
      params: { address_id: addressId }
    });
    return response.data;
  },

  getByProject: async (projectId, realEstateObjectId = null) => {
    const params = { project_id: projectId };
    if (realEstateObjectId) {
      params.real_estate_object_id = realEstateObjectId;
    }
    const response = await api.get('/documents', { params });
    return response.data;
  },

  getByAppointment: async (appointmentId) => {
    const response = await api.get('/documents', {
      params: { appointment_id: appointmentId }
    });
    return response.data;
  },

  getByAppointments: async (appointmentIds) => {
    if (!appointmentIds || appointmentIds.length === 0) return {};
    const response = await api.get('/documents/by-appointments', {
      params: { appointment_ids: appointmentIds.join(',') }
    });
    return response.data;
  },

  getByRealEstateObject: async (objectId) => {
    const response = await api.get('/documents', {
      params: { real_estate_object_id: objectId }
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/documents/${id}`);
    return response.data;
  },

  download: async (id, filename) => {
    const response = await api.get(`/documents/${id}/download`, {
      responseType: 'blob',
    });
    
    // Erstelle Download-Link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  openInBrowser: async (id, filename, mimeType) => {
    // Direkte URL mit Token für Authentifizierung öffnen
    const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
    const token = localStorage.getItem('token');
    const url = `${baseUrl}/api/documents/${id}/view?token=${encodeURIComponent(token)}`;
    window.open(url, '_blank');
  },

  getViewUrl: (id) => {
    // Gibt die URL zurück, um das Dokument direkt anzuzeigen (mit Token für Authentifizierung)
    const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
    const token = localStorage.getItem('token');
    return `${baseUrl}/api/documents/${id}/view?token=${encodeURIComponent(token)}`;
  },

  delete: async (id) => {
    const response = await api.delete(`/documents/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    // Use JSON for updates that include linked fields
    const updateData = {};
    if (data.title !== undefined) updateData.title = data.title;
    if (data.description !== undefined) updateData.description = data.description;
    if (data.document_type !== undefined) updateData.document_type = data.document_type;
    if (data.category !== undefined) updateData.category = data.category;
    if (data.linked_address_id !== undefined) updateData.linked_address_id = data.linked_address_id;
    if (data.linked_contact_person_id !== undefined) updateData.linked_contact_person_id = data.linked_contact_person_id;
    
    const response = await api.put(`/documents/${id}`, updateData);
    return response.data;
  },

  updateAccessRights: async (id, accessRights) => {
    const response = await api.put(`/documents/${id}/access-rights`, { access_rights: accessRights });
    return response.data;
  },
};

export default documentService;
